// import { Radio, RadioGroup, Select } from '@chakra-ui/react';
import React from 'react';
import {useCallback, useEffect, useState} from 'react';


const CheckboxSel= ({name, items, callBack, defaultValue}) => {
    const [options, setoptions] = useState([]);
    const [checked, setchecked] = useState([]);

    const changeSelect = useCallback(
        (idx) => (
            e,
        ) => {
            if (e.target.value) {
                checked[idx] = !checked[idx];
                const valToSend = {[name]: items.enum.filter((_, index) => checked[index])};
                callBack(valToSend);
            }
        },
        [callBack, checked, items.enum, name],
    );

    useEffect(() => {
        const optionsRes = items.enum.reduce(
            (res, elem, idx) => [...res, {val: elem, desc: items.enumDesc[idx]}],
            [],
        );
        setoptions(optionsRes);
        const res = new Array(optionsRes.lenght).map(
            (_, idx) => Array.isArray(defaultValue) && defaultValue.indexOf(items.enum[idx]) > -1,
        );
        res[1] = true;
        setchecked(res);
    }, [defaultValue, items]);

    return (
        <fieldset className="group-layout">
            {options.map((elem, idx) => (
                <div key={idx}>
                    <input
                        type="checkbox"
                        id={`custom-checkbox-${idx}`}
                        name={name}
                        value={name}
                        defaultChecked={checked[idx]}
                        onChange={changeSelect(idx)}
                    />
                    <label htmlFor={`r_${idx}`}>{elem.desc}</label>
                </div>
            ))}
        </fieldset>
    );
};

export default CheckboxSel;
